export default {
	methods: {
		classEstado(estado){
			let tag = '';
			switch(estado){
				case 0:
					tag = 'is-dark'
				break;
				case 1:
					tag = 'is-danger'
				break;
				case 2:
					tag = 'is-success'
				break;
				case 3:
					tag = 'is-light'
				break;
			}

			return tag
		},
		classEstadoText(estado){
			let tag = '';
			switch(estado){
				case 0:
					tag = 'has-text-dark'
				break;
				case 1:
					tag = 'has-text-danger'
				break;
				case 2:
					//tag = 'has-text-success'
				break;
				case 3:
					tag = 'disabled'
				break;
			}

			return tag	
		},
		estadoText(estado){
			let text = '';
			switch (estado) {
				case 0:
					text = 'normal'
					break;
				case 1:
					text = 'cancelada'
					break;
				case 2:
					text = 'en juego'
					break;
				case 3:
					text = 'terminada'
					break;
			}

			return text
		},
		setCookie(cname, cvalue, exdays = 7) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toUTCString();
			document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		},
		getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		},
	}
}